<template>
  <Card class="loyaltyCard" @click="toDetail(data)" :thumb="data?.img">
    <template #title>
      <h2>{{ data?.name || '商品名称' }}</h2>
    </template>
    <!-- <template #desc>
      <div>
        购买期限：{{ data.buyStartTime ? addEightHour(data.buyStartTime, 'day', '.') : '' }}-{{
          data.buyEndTime ? addEightHour(data.buyEndTime, 'day', '.') : ''
        }}
      </div>
    </template> -->
    <template #price>
      <div class="price">厂商建议零售价* ¥{{ data.dealerPrice || 0 }}</div>
    </template>
  </Card>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { addEightHour } from '@/util'
import Card from '@/components/shop/Card'

export default {
  props: ['data'],
  emits: ['link'],
  components: {
    Card
  },
  setup(props, { emit }) {
    let { data } = toRefs(props)
    const state = reactive({
      data: data.value
    })
    let toDetail = data => {
      emit('link', data)
    }
    return {
      ...toRefs(state),
      toDetail,
      addEightHour
    }
  }
}
</script>
<style lang="scss" scoped>
h2 {
  font-size: 14px !important;
  color: #333333;
  font-weight: bold;
}
.price {
  font-size: 14px !important;
  font-weight: 600;
  color: #3088c5;
}
</style>
